import usePrivateAxios from "@/common/api/usePrivateAxios"
import { ErrorResponse } from "@/common/types/errorResponse";
import { NotificationsConfigurationsValidationSchema } from "@/features/notifications/schemas/update.schema";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface useEstablishmentNotificationsConfigurationsRegisterNotificationsProps {
  companyId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

export const useEstablishmentNotificationsConfigurationsRegisterNotifications = ({ companyId, onSuccess, onError }: useEstablishmentNotificationsConfigurationsRegisterNotificationsProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationFn: (form: NotificationsConfigurationsValidationSchema) => {
      const payload = {
        company_notification_configurations: Object.keys(form).map((notification_klass) => {
          return {
            notification_klass,
            provider_klasses: form[notification_klass].value === 'all' ? [] : [form[notification_klass].value],
          }
        }),
        company_id: companyId,
      }

      return privateAxios.post(`/establishment/company_notification_configurations/register_configurations/`, payload);
    },
    onSuccess,
    onError,
  });
}
